(() => {
  const element = document.getElementById('flock-experiment-config');
  if (!element) return;
  const config = JSON.parse(element.textContent);
  if (config.designMode) return;
  const experiment = 'landing_pages_v1';
  const url = new URL(window.location.href);
  const qa = config.preview || ['control', 'landing'].includes(url.searchParams.get('flock_qa'));
  const key = `flock_${experiment}${qa ? '_qa' : ''}`;
  const root = config.root.endsWith('/') ? config.root : `${config.root}/`;
  const allowedAds = new Set(['52704710128834', '52704710839034', '52704710633034', '52704710389234', '52704710243434', '52704710762234', '52704710460234', '52704710326434', '52703321229434', '52703320463434', '52707757097434', '52708098139434', '52708098151434']);
  const existingAdTags = {
    'founder-origin_product-aware_founder-video_v2': '52704710762234',
    'founder-origin_product-aware_founder-video_v1': '52704710243434',
    'not-copy-and-paste_problem-aware_founder-video_v2': '52704710389234',
    'fits-the-hole_product-aware_install-demo_v1': '52704710326434',
    'not-copy-and-paste_unaware_product-demo_v1': '52704710128834',
    'not-copy-and-paste_problem-aware_founder-video_v1': '52704710633034',
    'not-copy-and-paste_unaware_product-demo_v2': '52704710839034',
    'one-gauge-all-readouts_solution-aware_product-demo_v1': '52704710460234',
    'concept_01_functional_clarity': '52703321229434',
    'concept_02_personalization': '52703320463434',
    A1: '52704710128834', A2: '52704710839034', B1: '52704710633034', B2: '52704710389234',
    C1: '52704710243434', C2: '52704710762234', D1: '52704710460234', D2: '52704710326434'
  };
  const existingCampaigns = new Set(['flock-gauge_2026-10_organic-reuse', 'flock_static_test_2026_10', 'flock_organic_videos_2026_10']);
  const existingTag = url.searchParams.get('utm_source') === 'meta' && url.searchParams.get('utm_medium') === 'paid_social' && existingCampaigns.has(url.searchParams.get('utm_campaign'));
  const ad = url.searchParams.get('flock_ad') || (existingTag ? existingAdTags[url.searchParams.get('utm_content')] : null);
  let assignment = null;
  let running = false;
  let observed = false;
  let cartMarked = false;

  function read() {
    try {
      const value = JSON.parse(localStorage.getItem(key));
      if (value && Date.now() - Date.parse(value.assigned_at) >= 30 * 86400000) {
        localStorage.removeItem(key); localStorage.removeItem(`${key}_identity`); return null;
      }
      return value && /^[a-f0-9-]{36}$/i.test(value.visitor_id) &&
        ['control', 'landing'].includes(value.variant) &&
        Date.now() - Date.parse(value.assigned_at) < 30 * 86400000 ? value : null;
    } catch { return null; }
  }

  function permitted() {
    return window.Shopify?.customerPrivacy?.analyticsProcessingAllowed() === true;
  }

  function emit(event) {
    if (!assignment || !permitted()) return;
    fetch(`${config.endpoint}/events`, {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ visitor_id: assignment.visitor_id, event }), keepalive: true,
      credentials: 'omit', signal: AbortSignal.timeout(3000)
    }).catch(() => {});
  }

  function formFields(form) {
    if (!assignment || !permitted()) return;
    const properties = { _flock_experiment: experiment, _flock_visitor: assignment.visitor_id,
      _flock_variant: assignment.variant };
    const itemFields = [...form.querySelectorAll('[name]')].filter(input => !input.disabled).map(input => input.name.match(/^items\[(\d+)\]\[id\]$/)?.[1]).filter(Boolean);
    const prefixes = itemFields.length ? [...new Set(itemFields)].map(index => `items[${index}][properties]`) : ['properties'];
    form.querySelectorAll('[data-flock-experiment]').forEach(input => {
      if (!prefixes.some(prefix => input.name.startsWith(`${prefix}[`))) input.remove();
    });
    for (const prefix of prefixes) for (const [name, value] of Object.entries(properties)) {
      const fieldName = `${prefix}[${name}]`;
      let input = [...form.elements].find(field => field.name === fieldName);
      if (!input) {
        input = document.createElement('input'); input.type = 'hidden'; input.name = fieldName;
        input.dataset.flockExperiment = 'true'; form.appendChild(input);
      }
      input.value = value;
    }
  }

  function decorate() {
    document.querySelectorAll('form[action$="/cart/add"]').forEach(formFields);
  }

  function attach() {
    decorate();
    if (!observed) {
      observed = true;
      new MutationObserver(mutations => {
        if (mutations.some(mutation => [...mutation.addedNodes].some(node => node.nodeType === 1 && !node.dataset?.flockExperiment))) decorate();
      }).observe(document.body, { childList: true, subtree: true });
    }
    if (!cartMarked && config.cartAssignments.includes(assignment.visitor_id)) {
      cartMarked = true; emit('cart');
    }
    fetch(`${root}cart/update.js`, {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { flock_experiment: experiment,
        flock_visitor: assignment.visitor_id, flock_variant: assignment.variant } }),
      signal: AbortSignal.timeout(3000)
    }).catch(() => {});
  }

  async function start() {
    if (running || !permitted()) return;
    assignment = read();
    const entry = (url.searchParams.get('flock_test') === experiment || existingTag) && allowedAds.has(ad) &&
      window.location.pathname === `${root}products/water-temp-gauge` && !url.searchParams.has('flock_assigned');
    if (!entry) { if (assignment) attach(); return; }
    running = true;
    try {
      localStorage.setItem(`${key}_available`, '1'); localStorage.removeItem(`${key}_available`);
      let identity = assignment?.visitor_id || localStorage.getItem(`${key}_identity`);
      if (!/^[a-f0-9-]{36}$/i.test(identity || '')) identity = crypto.randomUUID();
      localStorage.setItem(`${key}_identity`, identity);
      const response = await fetch(`${config.endpoint}/enroll`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' }, credentials: 'omit',
        body: JSON.stringify({ visitor_id: identity, ad_id: ad,
          is_test: qa, test_variant: qa ? url.searchParams.get('flock_qa') || null : null }),
        signal: AbortSignal.timeout(2500)
      });
      if (!response.ok) {
        if (response.status === 409) { localStorage.removeItem(key); localStorage.removeItem(`${key}_identity`); }
        return;
      }
      const result = await response.json();
      if (!result.enabled) return;
      assignment = result;
      localStorage.setItem(key, JSON.stringify(result));
      const target = new URL(url);
      target.pathname = `${root.slice(0, -1)}${result.destination}`;
      target.searchParams.set('flock_assigned', '1');
      if (qa) target.searchParams.set('flock_qa', result.variant);
      if (target.pathname !== window.location.pathname) {
        window.location.replace(target.href); return;
      }
      attach();
    } catch { }
    finally { running = false; }
  }

  document.addEventListener('submit', event => {
    if (event.target.matches('form[action$="/cart/add"]')) formFields(event.target);
  }, true);
  document.addEventListener('formdata', event => {
    if (!assignment || !permitted() || !event.target.matches('form[action$="/cart/add"]')) return;
    for (const name of [...event.formData.keys()]) {
      if (/^items\[\d+\]\[properties\]\[_flock_(experiment|visitor|variant)\]$/.test(name)) event.formData.delete(name);
    }
    const indexes = [...event.formData.keys()].map(name => name.match(/^items\[(\d+)\]\[id\]$/)?.[1]).filter(Boolean);
    const prefixes = indexes.length ? [...new Set(indexes)].map(index => `items[${index}][properties]`) : ['properties'];
    for (const prefix of prefixes) for (const [name, value] of Object.entries({
      _flock_experiment: experiment, _flock_visitor: assignment.visitor_id, _flock_variant: assignment.variant
    })) event.formData.set(`${prefix}[${name}]`, value);
  });
  document.addEventListener('visitorConsentCollected', () => {
    if (permitted()) { void start(); return; }
    assignment = null;
    try { localStorage.removeItem(key); localStorage.removeItem(`${key}_identity`); } catch { }
    document.querySelectorAll('[data-flock-experiment]').forEach(field => field.remove());
    fetch(`${root}cart/update.js`, { method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { flock_experiment: '', flock_visitor: '', flock_variant: '' } }) }).catch(() => {});
    fetch(`${root}cart.js`).then(response => response.json()).then(async cart => {
      for (const item of cart.items || []) {
        if (item.properties?._flock_experiment !== experiment) continue;
        const properties = { ...item.properties };
        delete properties._flock_experiment; delete properties._flock_visitor; delete properties._flock_variant;
        await fetch(`${root}cart/change.js`, { method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: item.key, properties }) });
      }
    }).catch(() => {});
  });
  function init() {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, event => {
        const lines = event.cartData?.items || (event.cartData ? [event.cartData] : []);
        const hasGauge = lines.some(line => (config.gaugeProductIds || []).includes(Number(line.product_id)));
        if (event.source === 'product-form' && (hasGauge || config.gaugeVariants.includes(Number(event.productVariantId)))) emit('cart');
      });
    }
    if (window.Shopify?.customerPrivacy) void start();
    else window.Shopify?.loadFeatures?.([{ name: 'consent-tracking-api', version: '0.1' }], error => { if (!error) void start(); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
